import type { Provider } from '@angular/core';
import { CapabilitySuggestionStore } from '@indutrust/capability-data';
import { FactoryDocumentsStore } from '../document/+state/factory-documents.store';
import { FactoryLogoStore } from '../factory/factory-logo.store';
import { FactoryStore } from '../factory/factory.store';
import { FactoryImagesStore } from '../image/+state/factory-images.store';
import { MachineParkStore } from '../machine-park/+state/machine-park.store';
import { FactoryProjectReferencesStore } from '../project-reference/+state/factory-project-references.store';
import { VirtualTourStore } from '../virtual-tour/+state/virtual-tour.store';
import { FactoryEditFormStore } from './+state/factory-edit-form.store';
import { FactoryEditUiStore } from './+state/factory-edit-ui.store';

/**
 * Bundles every signal store required by the factory editor page tree.
 *
 * @example
 * Component({
 *   providers: [provideFactoryEditStores(), provideFactoryEditI18n()],
 * })
 */
export function provideFactoryEditStores(): Provider[] {
  return [
    FactoryStore,
    FactoryEditFormStore,
    FactoryEditUiStore,
    FactoryDocumentsStore,
    FactoryImagesStore,
    FactoryLogoStore,
    MachineParkStore,
    CapabilitySuggestionStore,
    FactoryProjectReferencesStore,
    VirtualTourStore,
  ];
}
